import api from 'api';

const url = 'api/profile';

export default {
    save: mode => api.patch({path: url,  params: {privacy_mode: mode}})
}